import { enableProdMode, StaticProvider } from '@angular/core';
import { BdAppConfigRequest, BdAppConfigResponse } from '@bindoc-projects/app-config-domain-lib';
import { BD_FRONTEND_APP_CONFIG } from '@bindoc-projects/platform-lib/data';
import { BdApplicationBootstrap } from './application.bootstrap';

/**
 * Loads the frontend app configuration and enables Angular prod mode
 * when the loaded config environment is production or staging.
 */
export async function loadAppConfig(
  appConfigRequest: BdAppConfigRequest,
  environment: { configRequestUrl: string },
): Promise<BdAppConfigResponse> {
  const appConfig = await BdApplicationBootstrap.loadFrontendConfig(
    appConfigRequest,
    environment,
  );

  if (
    appConfig.environment === 'production' ||
    appConfig.environment === 'staging'
  ) {
    enableProdMode();
  }

  return appConfig;
}

/**
 * Provides the loaded frontend app configuration via DI.
 */
export function provideAppConfig(appConfig: BdAppConfigResponse): StaticProvider {
  return {
    provide: BD_FRONTEND_APP_CONFIG,
    useValue: appConfig,
  };
}


